export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11637.7c0d3b6a.jpg";